import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

domReady(() => {
  const tripleCtas = document.querySelectorAll('.triple-cta');

  tripleCtas.forEach((tripleCta) => {
    const swiperEl = tripleCta.querySelector('.triple-cta__carousel');
    if (!swiperEl) return;

    const isDesktopCarousel = swiperEl.dataset.desktopCarousel === '1';

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 700,

      breakpoints: {
        600: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2, 
          spaceBetween: 30,
        },
          
        1200: isDesktopCarousel
          ? { slidesPerView: 3, spaceBetween: 30 }
          : { enabled: false },
      },

      navigation: {
        prevEl: [...tripleCta.querySelectorAll('.swiper-button-prev')],
        nextEl: [...tripleCta.querySelectorAll('.swiper-button-next')],
      },
    });
  });
});
